var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasstab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MASSTAB",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #MASSTAB .cls-1,\n      #MASSTAB .cls-2 {\n        fill: #f5f5f5;\n      }\n\n      #MASSTAB .cls {\n        stroke: #f5f5f5;\n        stroke-width: 0.5px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_338",
    "data-name": "Pfad 338",
    className: "cls-2",
    d: "M16,0A16,16,0,1,0,32,16,15.983,15.983,0,0,0,16,0Zm0,30A14,14,0,1,1,30,16,14.172,14.172,0,0,1,16,30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_339",
    "data-name": "Pfad 339",
    className: "cls-1 cls",
    d: "M25.2,15.2H6.7v6.9H25.2Zm-.8,6.2H7.4V16H9.6v3.1h.8V16h2.2v1.9h.8V16h2.2v3.1h.8V16h2.2v1.9h.8V16h2.2v3.1h.8V16h2.2v5.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_340",
    "data-name": "Pfad 340",
    className: "cls-1",
    d: "M25.4,12.5V9.4h-1v3.1H7.5V9.4h-1v3.1h0v1H25.4Z",
    transform: "translate(0 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasstab);
export default __webpack_public_path__ + "static/media/masstab.be01534d69e11bb6afb999af818f3d10.svg";
export { ForwardRef as ReactComponent };